import axios from '../utlis/interceptor'
import { BASE_URL, GET_PARTNERS, VERIFY_PARTNER } from '../resources/APIEndpoints'

function OrganisationService() {
  this.getAllPartners = (body) => axios.post(BASE_URL + GET_PARTNERS, body)
  this.getPartnersById = (body) => axios.post(BASE_URL + GET_PARTNERS, body)
  this.verifyPartner = (body) => axios.post(BASE_URL + VERIFY_PARTNER, body)
}

export default new OrganisationService()